import { useInterviewStore } from '@/store/interviewStore'
import { InterviewSummary } from '@/components/interview/InterviewSummary'
import { useInterviewSessionContext } from '@/context/InterviewSessionContext'
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export function SummaryScreen() {
  const { language, handleBackToHome } = useInterviewSessionContext()
  const store = useInterviewStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (!store.config) {
      navigate('/', { replace: true })
    }
  }, [store.config, navigate])

  return (
    <div className="container">
      <InterviewSummary language={language} transcripts={store.transcripts} onBack={handleBackToHome} />
    </div>
  )
}
